import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách nội dung (contents) của một danh mục Sản phẩm - Giải pháp
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @param {number|string} categoryId - ID của productSolutionCategory
 * @returns {Promise<Array>} - Mảng contents:
 *   [{ id, productSolutionCategoryId, categoryName, categorySlug, description, images: [{id, imageUrl, sortOrder}] }]
 */
export const getProductSolutionContentsByCategory = async (languageCode, categoryId) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.PRODUCT_SOLUTION_CONTENTS.GET_BY_CATEGORY(languageCode, categoryId)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        } else if (Array.isArray(data)) {
            return data;
        }

        return [];
    } catch (error) {
        console.error(
            `[ProductSolutionContents] Lỗi khi lấy contents (lang=${languageCode}, categoryId=${categoryId}):`,
            error.message ?? error
        );
        throw error;
    }
};
